import { z } from 'zod';

import { WorkoutPlanId } from '../BrandedIds';
import { BaseUpsertTransactionSideEffect } from './BaseUpsertTransactionSideEffect';

export const UpsertPaymentDeferralSideEffectContext = BaseUpsertTransactionSideEffect.extend({
  workoutPlanId: WorkoutPlanId,
});
export const UpsertPaymentDeferralSideEffect = UpsertPaymentDeferralSideEffectContext.extend({
  type: z.literal('upsertPaymentDeferral'),
});
export type UpsertPaymentDeferralSideEffect = z.infer<typeof UpsertPaymentDeferralSideEffect>;
